import { GAMES } from './games'
import { convertCase } from '@utils/miscUtils'
import { INTERNAL_CONSTANTS } from '@constants/internalConstants'

const { DEVICES, MODES } = INTERNAL_CONSTANTS

// Outcome of resolving a launch against the game registry — consumed by the
// bootstrap gate and the layout controller to decide what to render.
export const GAME_VIEW_STATUS = {
  READY: 'READY',
  GAME_NOT_FOUND: 'GAME_NOT_FOUND',
  MODE_PROHIBITED: 'MODE_PROHIBITED',
}

// Responsive device (DESKTOP/TABLET/MOBILE/MINI) -> play mode (NORMAL/MINI).
// Only the embedded MINI device maps to the MINI layout; everything else is NORMAL.
export const resolveMode = (device) =>
  device === DEVICES.MINI ? MODES.MINI : MODES.NORMAL

/**
 * Single source of truth for "can we render this game in this view?".
 * `gameCode` is already uppercased at the launch-param layer; convertCase keeps
 * this defensive against any direct caller passing a raw value.
 */
export const resolveGameView = ({ gameCode, device }) => {
  const mode = resolveMode(device)
  const game = GAMES[convertCase({ value: gameCode })]

  if (!game) return { status: GAME_VIEW_STATUS.GAME_NOT_FOUND, game: null, mode }
  if (!game.modes.includes(mode)) return { status: GAME_VIEW_STATUS.MODE_PROHIBITED, game, mode }

  return { status: GAME_VIEW_STATUS.READY, game, mode }
}
